import { render, staticRenderFns } from "./dialogs.vue?vue&type=template&id=1db8f8cc&scoped=true&"
import script from "./dialogs.vue?vue&type=script&lang=js&"
export * from "./dialogs.vue?vue&type=script&lang=js&"
import style0 from "./dialogs.vue?vue&type=style&index=0&id=1db8f8cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db8f8cc",
  null
  
)

export default component.exports